import AnatomyV2BodyParts from '~/pages/anatomyV2/bodyParts/libs/components/AnatomyV2BodyParts'
import { TPageProps } from '~/shared/types/commonTypes'

const BodyPartsAnatomyV2 = (props: TPageProps) => (
  <AnatomyV2BodyParts {...props} />
)

export default BodyPartsAnatomyV2
